import { render, staticRenderFns } from "./SponsorshipPackages.vue?vue&type=template&id=8678fdec&"
import script from "./SponsorshipPackages.vue?vue&type=script&lang=js&"
export * from "./SponsorshipPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports